// import { equal } from "assert";
// import jQuery from "jquery";
import slick from "slick-carousel";

document.addEventListener("DOMContentLoaded", function () {
  const testimonialCarousel = jQuery(".js-testimonial-carousel");

  if (testimonialCarousel.length) {
    testimonialCarousel.each(function () {
      const carousel = jQuery(this);
      const carouselOptions = {
        dots: true,
        arrows: false,
        infinite: true,
        speed: 300,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: true,
        prevArrow: ".js-testimonial-carousel-prev",
        nextArrow: ".js-testimonial-carousel-next",
        dots: true,
        appendDots: ".js-testimonial-carousel-dots",
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      };

      carousel.slick(carouselOptions);
    });
  }

  const eventCarousel = jQuery(".js-event-carousel");

  if (eventCarousel.length) {
    function setEqualHeight() {
      var maxHeight = 0;

      jQuery(".slick-slide").css("height", "auto");

      jQuery(".slick-slide").each(function () {
        var thisHeight = jQuery(this).outerHeight();
        if (thisHeight > maxHeight) {
          maxHeight = thisHeight;
        }
      });

      jQuery(".slick-slide").css("height", maxHeight + "px");
    }

    setEqualHeight();

    // Adjust height on window resize
    jQuery(window).resize(function () {
      setEqualHeight();
    });

    eventCarousel.each(function () {
      const carousel = jQuery(this);
      const carouselOptions = {
        dots: true,
        arrows: false,
        infinite: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        adaptiveHeight: true,
        arrows: true,
        prevArrow: ".js-event-carousel-prev",
        nextArrow: ".js-event-carousel-next",
        dots: true,
        appendDots: ".js-event-carousel-dots",
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
        ],
      };

      carousel.slick(carouselOptions);
    });
  }

  const imageSliderCarousel = jQuery(".js-image-carousel");

  if (imageSliderCarousel.length) {
    imageSliderCarousel.each(function () {
      const carousel = jQuery(this);
      const carouselOptions = {
        dots: true,
        arrows: true,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: ".js-image-carousel-prev",
        nextArrow: ".js-image-carousel-next",
        appendDots: ".js-image-carousel-dots",
      };

      carousel.slick(carouselOptions);
    });
  }
});
